var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 3.81818C8.39859 3.81818 7.90919 4.30791 7.90919 4.90986C7.90919 5.51127 8.39859 6.00056 9.00016 6.00056C9.60173 6.00056 10.0911 5.51127 10.0911 4.90986C10.0911 4.30791 9.60173 3.81818 9.00016 3.81818Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 7.63637C8.54814 7.63637 8.18181 8.0027 8.18181 8.45455V13.3636C8.18181 13.8155 8.54814 14.1818 8.99999 14.1818C9.45185 14.1818 9.81817 13.8155 9.81817 13.3636V8.45455C9.81817 8.0027 9.45185 7.63637 8.99999 7.63637Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.93172,
    cy: 8.76513,
    r: 8.24804,
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e341375165e62c6261460c026fc15c6d.svg";
export { ForwardRef as ReactComponent };